module.exports = __webpack_public_path__ + "img/abc-classic.3dbe52e6.png";